<template>
  <BaseVeeForm
    :action="submitForm"
    v-slot="{ isPending, isRejected, invalid }"
    @success="$emit('success')"
    @failure="$emit('failure')"
  >
    <BaseCard>
      <BaseCardBody>
        <BaseHeading :level="2" class="mb-4"> Create new password </BaseHeading>
        <div class="space-y-6">
          <ValidationProvider rules="required" name="email" tag="div" vid="email">
            <template #default="{ errors, failed }">
              <BaseFormGroup>
                <BaseFormLabel for="email"> Email address </BaseFormLabel>
                <BaseFormInput
                  id="email"
                  type="email"
                  v-model="formData.email"
                  :disabled="isPending"
                />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>

          <ValidationProvider
            rules="required|confirmed:password_confirmation"
            name="password"
            tag="div"
            vid="password"
          >
            <template #default="{ errors, failed }">
              <BaseFormGroup>
                <BaseFormLabel for="password"> Password </BaseFormLabel>
                <BaseFormInput
                  id="password"
                  type="password"
                  v-model="formData.password"
                  :disabled="isPending"
                />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>

          <ValidationProvider
            rules="required"
            name="password confirmation"
            tag="div"
            vid="password_confirmation"
          >
            <template #default="{ errors, failed }">
              <BaseFormGroup>
                <BaseFormLabel for="password_confirmation"> Confirm password </BaseFormLabel>
                <BaseFormInput
                  id="password_confirmation"
                  type="password"
                  v-model="formData.password_confirmation"
                  :disabled="isPending"
                />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </template>
          </ValidationProvider>
        </div>
        <ValidationProvider name="token" tag="div" vid="token">
          <template #default="{ errors, failed }">
            <BaseFormGroup>
              <BaseFormInput
                id="token"
                type="hidden"
                v-model="formData.token"
                :disabled="isPending"
              />
              <BaseFormInlineMessage v-if="failed" danger>
                {{ errors[0] }}
              </BaseFormInlineMessage>
            </BaseFormGroup>
          </template>
        </ValidationProvider>
      </BaseCardBody>
      <BaseCardBody>
        <BaseButton primary class="w-full" :disabled="invalid || isPending || isRejected">
          Reset password
        </BaseButton>
      </BaseCardBody>
    </BaseCard>
  </BaseVeeForm>
</template>

<script>
export default {
  name: 'PasswordResetForm',

  props: {
    token: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      formData: {
        email: this.$route.query?.email || '',
        password: '',
        password_confirmation: '',
        token: this.$route.params?.token || '',
      },
    };
  },

  methods: {
    async submitForm() {
      const {
        $store: { dispatch },
        formData,
      } = this;

      try {
        const response = await dispatch({
          type: 'ui/auth/passwordReset',
          formData,
        });

        this.$emit('success', response);

        return Promise.resolve(response);
      } catch (error) {
        this.$emit('failure', error);
        return Promise.reject(error);
      }
    },
  },
};
</script>
